import { PaymentMethodCreate } from './PaymentMethodCreate'
import { PaymentMethodEdit } from './PaymentMethodEdit'
import { PaymentMethodList } from './PaymentMethodList'
import { PaymentMethodShow } from './PaymentMethodShow'

export { PaymentMethodCreate, PaymentMethodEdit, PaymentMethodList, PaymentMethodShow }
